import { z } from 'zod'

/** Envelope events whose payload is only the shared envelope fields. */
export const PLAIN_ENVELOPE_WEBHOOK_EVENTS_BEFORE_COMPLETED = ['envelope.sent'] as const

export const PLAIN_ENVELOPE_WEBHOOK_EVENTS_AFTER_COMPLETED = [
  'envelope.declined',
  'envelope.voided',
  'envelope.expired',
  'envelope.deleted',
  'signer.sent',
  'signer.viewed',
  'signer.signed',
  'signer.declined',
  'signer.reminded',
  'signer.paper_copy_requested',
] as const

/** `envelope.completed` adds the document list. */
export const ENVELOPE_COMPLETED_WEBHOOK_EVENT = 'envelope.completed' as const

/** Question events add the thread and its participants. */
export const QUESTION_WEBHOOK_EVENTS = ['question.asked', 'question.replied'] as const

/** Envelope events with no extra fields, in either side of `envelope.completed`. */
export const PLAIN_ENVELOPE_WEBHOOK_EVENTS = [
  ...PLAIN_ENVELOPE_WEBHOOK_EVENTS_BEFORE_COMPLETED,
  ...PLAIN_ENVELOPE_WEBHOOK_EVENTS_AFTER_COMPLETED,
] as const

/** Events about one envelope; every one carries `envelopeId`. */
export const ENVELOPE_WEBHOOK_EVENTS = [
  ...PLAIN_ENVELOPE_WEBHOOK_EVENTS_BEFORE_COMPLETED,
  ENVELOPE_COMPLETED_WEBHOOK_EVENT,
  ...PLAIN_ENVELOPE_WEBHOOK_EVENTS_AFTER_COMPLETED,
  ...QUESTION_WEBHOOK_EVENTS,
] as const

/**
 * Events about an organization's credit. They reference no envelope, go to the
 * live webhook URL, and are sent only once billing is switched on.
 */
export const BILLING_WEBHOOK_EVENTS = [
  'billing.balance_low',
  'billing.balance_empty',
  'billing.auto_reload_failed',
  'billing.credit_added',
] as const

export const WEBHOOK_EVENTS = [...ENVELOPE_WEBHOOK_EVENTS, ...BILLING_WEBHOOK_EVENTS] as const

export const webhookEventNameSchema = z.enum(WEBHOOK_EVENTS)

export type WebhookEventName = z.infer<typeof webhookEventNameSchema>

/** Envelope events only: what an envelope emits, and what a dashboard test event may be. */
export const envelopeWebhookEventNameSchema = z.enum(ENVELOPE_WEBHOOK_EVENTS)

export type EnvelopeWebhookEventName = z.infer<typeof envelopeWebhookEventNameSchema>

export type BillingWebhookEventName = (typeof BILLING_WEBHOOK_EVENTS)[number]
